import { react, useState, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import LoadingIndicator from '../LoadingIndicator'
import TokenService from '../../services/TokenService';
import styles from '../Pickups/PickupWizard.module.css'; // Import css modules stylesheet as styles
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const states = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
    'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
    'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
    'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
    'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma',
    'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee',
    'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

const zipCodeRegex = /^\d{5}$/;

export default function ShippingDetails(props) {
    const handleClose = () => {
        props.Close(false);
    };

    const [formValidation, setFormValidation] = useState({ errors: [], isValid: false });

    const [customerAddressStreet, setCustomerAddressStreet] = useState('');
    const [customerAddressStreet2, setCustomerAddressStreet2] = useState('');
    const [customerAddressCity, setCustomerAddressCity] = useState('');
    const [customerAddressState, setCustomerAddressState] = useState('');
    const [customerAddressZip, setCustomerAddressZip] = useState('');

    function isValidated() {

        let isValid = true;
        let errors = [];
       

        

        if (customerAddressStreet.trim() === '') {
            //if (!_allowBlankFields.current) {
                errors["CustomerAddressStreet"] = "Please enter your Street";
           // }
            isValid = false;
        }

        if (customerAddressCity.trim() === '') {
           // if (!_allowBlankFields.current) {
                errors["CustomerAddressCity"] = "Please enter your City";
           // }
            isValid = false;
        }

        if (customerAddressState.trim() === '') {
            //if (!_allowBlankFields.current) {
                errors["CustomerAddressState"] = "Please enter your State";
           // }
            isValid = false;
        }

        if (customerAddressZip.trim() === '') {
            //if (!_allowBlankFields.current) {
            errors["CustomerAddressZip"] = "Please enter your Zip code";
            //}
            isValid = false;
        }
        else {
            const isValidZipCode = zipCodeRegex.test(customerAddressZip.trim());
            if (!isValidZipCode) {
                errors["CustomerAddressZip"] = "Invalid Zip code";
                isValid = false;
            }
        }
      

        return {
            isValid: isValid,
            errors: errors
        }
    }

    function validateAndSave() {
        let validation = isValidated();

        if (validation.isValid) {
            let shippingAddress = {
                street: customerAddressStreet.trim(),
                street2: customerAddressStreet2.trim(),
                city: customerAddressCity.trim(),
                state: customerAddressState,
                zip: customerAddressZip
            }
            props.Close(true, shippingAddress);
        }
        else {
            setFormValidation(validation);
        }
    }

    //let formValidation = isValidated();

    return (<div>
        <Dialog
            open={true}
            onClose={() => props.Close(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Request for Printed Materials
            </DialogTitle>
            <DialogContent>
                <div style={{maxWidth:'350px'} }>
                    <div>
                        Send us a request for printed materials and we will have them shipped to your address.
                    </div>
                    <div className={styles.ContactSection} style={{marginTop:'10px'} }>
                        <div className={styles.ContactSectionHeader} style={{marginBottom:'10px'} }>
                            <span>Delivery Address</span>

                        </div>
                        <div className={styles.ContactSectionBody}>
                           
                           <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressStreet'] !== undefined} label="Street" onChange={(e) => setCustomerAddressStreet(e.target.value)} value={customerAddressStreet} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressStreet'] !== undefined ? formValidation.errors['CustomerAddressStreet'] : ''}</div>
                        </div>
                        <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressStreet2'] !== undefined} label="Apt/Suite/Other" onChange={(e) => setCustomerAddressStreet2(e.target.value)} value={customerAddressStreet2} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressStreet2'] !== undefined ? formValidation.errors['CustomerAddressStreet2'] : ''}</div>
                        </div>
                        <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressCity'] !== undefined} label="City" onChange={(e) => setCustomerAddressCity(e.target.value)} value={customerAddressCity} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressCity'] !== undefined ? formValidation.errors['CustomerAddressCity'] : ''}</div>
                        </div>
                        <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                            <FormControl>
                                <InputLabel>State</InputLabel>
                                <Select className={styles.ContactSectionText}
                                    variant="outlined"
                                    style={{ backgroundColor: '#efefef', borderBottom: '2px solid #818181 !important', borderRadius:'5px'} }
                                    error={formValidation.errors['CustomerAddressState'] !== undefined}
                                    value={customerAddressState}
                                    onChange={(e) => setCustomerAddressState(e.target.value)}
                                    label="Select a state"
                                >
                                    {states.map((state) => (
                                        <MenuItem key={state} value={state}>
                                            {state}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                           {/* <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressState'] !== undefined} label="State" onChange={(e) => setCustomerAddressState(e.target.value)} value={customerAddressState} variant="outlined" />*/}
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressState'] !== undefined ? formValidation.errors['CustomerAddressState'] : ''}</div>
                        </div>
                        <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressZip'] !== undefined} label="Zip" onChange={(e) => setCustomerAddressZip(e.target.value)} value={customerAddressZip} variant="outlined" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength:5 }} />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressZip'] !== undefined ? formValidation.errors['CustomerAddressZip'] : ''}</div>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.Close(false)} autoFocus>
                    Cancel
                </Button>
                <Button onClick={() => validateAndSave()}>
                    Send
                </Button>
            </DialogActions>
        </Dialog>
    </div>)
    


}